
import { getTripConsignorReportTemplate, getTripReportTemplate } from "_services";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import PartyLRPaymentDetails from "./PartyLRPaymentDetails";
import TransportTripDetails from "./TransportTripDetails";
import Loading from "pages/Loading";

const SupplierSheet = () => {
  const location = useLocation();
  const [details, setDetails] = useState({});
  const [ids, setIds] = useState({
    tripId: "",
    consignor_id: "",
  });
  const [loading, setLoading] = useState(false);


 useEffect(() => {
  const currentUrl = new URL(window.location.href);
  const redirectUrl = currentUrl.searchParams.get("redirect");

  let trip_id_redirect = "";
  let consignor_id = "";

  if (redirectUrl) {
    try {
      let parsedRedirect = redirectUrl.replace(
        "/consignor_id=",
        "&consignor_id="
      );

      const redirectObj = new URL(parsedRedirect);
      trip_id_redirect = redirectObj.searchParams.get("trip_id");
      consignor_id = redirectObj.searchParams.get("consignor_id");
    } catch (error) {
      console.error("Invalid redirect URL:", error);
    }
  }

  if (!trip_id_redirect) return;

  setIds({
    tripId: trip_id_redirect,
    consignor_id,
  });

  getTemplateForTripAndConsignor(trip_id_redirect, consignor_id);
}, []); // 👈 remove location dependency


  const getTemplateForTripAndConsignor = async (trip_id, consignor_id) => {
  try {
    setLoading(true);

    const res = consignor_id
      ? await getTripConsignorReportTemplate({ trip_id, consignor_id })
      : await getTripReportTemplate({ trip_id });

    if (res?.responseCode === 200) {
      setDetails(res.data);
    }
  } catch (error) {
    console.error("Error fetching template:", error);
  } finally {
    setLoading(false);
  }
};


  console.log(ids)

  return (
    <div>
     {loading ? (
     <div className="loaderBg" style={{ textAlign: "center" }}><Loading /></div>
    ) : ids?.consignor_id ? (
      <PartyLRPaymentDetails {...details} />
    ) : (
      <TransportTripDetails {...details} />
    )}
    </div>
  );
};

export default SupplierSheet;


